import { FILTER_TYPES } from 'components/FilterPod';
import jMoment from 'moment-jalaali';
import { REQUEST_STATUSES } from '../components/Columns';

const filters = (getAccounts) => [

  {
    title: 'محدوده تاریخ و زمان وقوع',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'eqDateTimeRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    disableDelete: true,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'کسب‌وکار سرویس‌دهنده',
    label: 'انتخاب کسب‌وکار',
    keyName: 'businessId',
    id: 3233,
    value: null,
    filterType: FILTER_TYPES.autocomplete,
    getValueLabel: (v) => v?.label ?? v?.name ?? '',
    filterProps: {
      getList: getAccounts,
      useLocalState: true,
    },
  },
  {
    title: 'وضعیت درخواست',
    label: 'وضعیت',
    keyName: 'statusCode',
    id: 3236,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: Object.keys(REQUEST_STATUSES).map((v) => ({
        value: v,
        label: REQUEST_STATUSES?.[v],
      })),
    },
  },
  {
    title: 'شناسه درخواست',
    label: 'شناسه درخواست',
    keyName: 'id',
    id: 3228,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      placeholder: 'شناسه درخواست مورد نظر',
      dir: 'ltr',
      englishNumber: true,
    },
  },
];

export default filters;
